import { loadWithChunkRetry } from '@muse-web/router'

export const loadUploadAudioFile = () =>
    loadWithChunkRetry(
        () => import(/* webpackChunkName: 'audio-upload-transfer' */ './uploadAudioFile'),
    )

export const preloadUploadAudioFile = () => {
    loadUploadAudioFile().catch(() => undefined)
}
